export default __webpack_public_path__ + "static/media/element_spec_41.eeffff79.webp";